var _effectorFileName = "/builds/gmini/front-ui-kit/src/Select/components/Popover/Popover.tsx";
import React from 'react';
import { PopoverStyled, Content } from './Popover.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const Popover = ({
  onClose,
  children,
  heightSelectPx,
  maxHeight,
  inputRef,
  paperStyles,
  anchorEl,
  onScroll,
  contentStyles,
  contentStyled
}) => {
  var _inputRef$current, _inputRef$current2;

  const viewPortHeight = window.scrollY + window.innerHeight;
  const spaceBottomLessMin = viewPortHeight - (Number((_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.getBoundingClientRect().top) + heightSelectPx) < maxHeight;
  const contentWidth = (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.getBoundingClientRect().width;
  return /*#__PURE__*/_jsx(PopoverStyled, {
    spaceBottomLessMin: spaceBottomLessMin,
    open: Boolean(anchorEl),
    onClose: onClose,
    anchorOrigin: {
      vertical: spaceBottomLessMin ? 'top' : 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: spaceBottomLessMin ? 'bottom' : 'top',
      horizontal: 'left'
    },
    anchorEl: anchorEl,
    disableAutoFocus: true,
    disableEnforceFocus: true,
    disableRestoreFocus: true,
    paperStyles: paperStyles,
    children: /*#__PURE__*/_jsx(Content, {
      width: contentWidth ? `${contentWidth}px` : '',
      maxHeight: maxHeight,
      onScrollCapture: onScroll,
      additionalStyles: contentStyled,
      style: contentStyles,
      children: children
    })
  });
};